import React, { useState, useRef } from "react";
import { createPortal } from "react-dom";
import ReactMarkdown from "react-markdown";

const Tooltip = ({ text, children }) => {
  const [show, setShow] = useState(false);
  const [pos, setPos] = useState({
    top: 0,
    left: 0,
    renderAbove: false,
    maxHeight: 300,
  });
  const containerRef = useRef(null);

  const handleMouseEnter = () => {
    if (containerRef.current) {
      const rect = containerRef.current.getBoundingClientRect();

      // Calculate available space
      const spaceBelow = window.innerHeight - rect.bottom;
      const spaceAbove = rect.top;

      // Render in the direction with more space
      const renderAbove = spaceAbove > spaceBelow;

      // Leave a 20px margin from the screen edge
      const maxAvailableSpace = renderAbove ? spaceAbove - 20 : spaceBelow - 20;

      setPos({
        top: renderAbove ? rect.top - 10 : rect.bottom + 10,
        left: rect.left + rect.width / 2,
        renderAbove,
        maxHeight: maxAvailableSpace > 100 ? maxAvailableSpace : 100,
      });
      setShow(true);
    }
  };

  const tooltipContent = typeof text === "string" ? text.trim() : text;

  return (
    <div
      className="inline-block"
      ref={containerRef}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={() => setShow(false)}
    >
      {children}
      {show &&
        createPortal(
          <div
            className={`fixed z-[9999] bg-black text-white text-xs rounded px-3 py-2 w-80 whitespace-pre-wrap shadow-lg transform -translate-x-1/2 overflow-y-auto ${pos.renderAbove ? "-translate-y-full" : ""}`}
            style={{ top: pos.top, left: pos.left, maxHeight: pos.maxHeight }}
          >
            <div className="markdown-content">
              <ReactMarkdown>{tooltipContent}</ReactMarkdown>
            </div>
          </div>,
          document.body,
        )}
    </div>
  );
};

export default Tooltip;
